import { render, staticRenderFns } from "./OwnerBookingInfo.vue?vue&type=template&id=5bb216ac&"
import script from "./OwnerBookingInfo.vue?vue&type=script&lang=js&"
export * from "./OwnerBookingInfo.vue?vue&type=script&lang=js&"
import style0 from "./OwnerBookingInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports